import React from "react";

const ServerError = ({ message }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        background: "#f9fafb",
        fontFamily: "Inter, sans-serif",
      }}
    >
      <div style={{ textAlign: "center", padding: 40 }}>
        <div
          style={{
            fontSize: 80,
            fontWeight: 800,
            color: "#EF4444",
            lineHeight: 1,
          }}
        >
          500
        </div>
        <h2
          style={{
            fontSize: 22,
            fontWeight: 700,
            color: "#071b33",
            margin: "12px 0 8px",
          }}
        >
          Server Error
        </h2>
        <p
          style={{
            fontSize: 14,
            color: "#6b7280",
            margin: "0 0 8px",
            maxWidth: 400,
          }}
        >
          {message || "Something went wrong on our end. Please try again."}
        </p>
        <div
          style={{
            display: "flex",
            gap: 10,
            justifyContent: "center",
            marginTop: 24,
          }}
        >
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: "10px 24px",
              background: "#0062FE",
              color: "#fff",
              border: "none",
              borderRadius: 8,
              cursor: "pointer",
              fontSize: 14,
              fontWeight: 600,
            }}
          >
            Reload Page
          </button>
          <button
            onClick={() => window.history.back()}
            style={{
              padding: "10px 24px",
              background: "#fff",
              color: "#374151",
              border: "1px solid #d1d5db",
              borderRadius: 8,
              cursor: "pointer",
              fontSize: 14,
              fontWeight: 600,
            }}
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServerError;
